// extracted by mini-css-extract-plugin
module.exports = {"payment":"payment_payment__3HwVz","pagoTotal":"payment_pagoTotal__2a-Ee","mercadoPago":"payment_mercadoPago__3p6TL","boton":"payment_boton__3KGmU"};